import React from 'react';
import {Keyboard, StyleSheet, Text, View} from 'react-native';
import {useDispatch} from 'react-redux';
import Animated, {
    Extrapolate,
    interpolate,
    useAnimatedStyle,
    useSharedValue,
    withRepeat,
    withTiming
} from "react-native-reanimated";
import {setLogsVisibility} from "../reducers/configSlice";
import LogsContainer from "../components/LogsContainer";
import HiddenLongPress from "../components/HiddenLongPress";
import {EventBus} from "../services/EventBus";

import {actuatedWithoutScale} from "../services/helpers/stylingHelpers";

const WaitingConfiguration = () => {
    const dispatch = useDispatch()

    let circles = [], center, outputRange, opacity
    const componentColor = 'rgba(0, 116, 139, 1)';

    const animatedCenter = useSharedValue(0)
    animatedCenter.value = withRepeat(withTiming(1, {duration: 3000}), -1, true);

    for (center = 1; center <= 4; center++) {
        outputRange = (center === 1 ? [0.5, 1] : center === 2 ? [2, 1] : center === 3 ? [3.5, 1] : [5, 1]);
        opacity = center === 1 ? 1 : center === 2 ? 0.55 : center === 3 ? 0.40 : 0.25;

        const animatedCenterStyle = useAnimatedStyle( () => {
            const scale = interpolate(animatedCenter.value, [0, 1], outputRange, Extrapolate.CLAMP)

            return {
                transform: [{scale: scale}]
            }
        })

        circles.push(
            <Animated.View key={center} style={[styles.circle, {backgroundColor: Color(componentColor).alpha(1).hex()}, {opacity: opacity}, animatedCenterStyle]}/>
        )
    }
    const _disconnect = async () => {
        EventBus.emit('destroyInstance');
    }

    const _showConnectionLogs = async () => {
        Keyboard.dismiss()
        dispatch(setLogsVisibility(true))
    }

    return (
        <View style={styles.container}>
            <View style={styles.circlesContainer}>
                <View style={styles.circleWrapper}>
                    {circles}
                </View>
            </View>
            <Text style={styles.waitingText}>
                {translate("Waiting configuration")}
            </Text>

            <HiddenLongPress onEvent={_disconnect} position={'topRight'}/>
            <HiddenLongPress onEvent={_showConnectionLogs} position={'bottomLeft'}/>
            <LogsContainer />
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        backgroundColor: '#121B2B',
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center'
    },
    waitingText: {
        position: 'absolute',
        color: 'white',
        fontSize: actuatedWithoutScale(40),
        fontWeight: '500',
        textAlign: 'center',
        marginRight: '20%',
        marginLeft: '20%'
    },
    circlesContainer: {
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
        flex: 1,
    },
    circleWrapper: {
        width: 200,
        height: 200
    },
    circle: {
        position: 'absolute',
        top: 80,
        left: 80,
        width: 50,
        height: 50,
        borderRadius: 31
    },
});

export default WaitingConfiguration
